import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientControllerApi } from "../services";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  getXtenantId,
  useBaseContent,
} from "../utils/utils";

/** A row from `getAllPatientForSmsRecord` — an SMS projection, not a `Patient`. */
export interface ChatPatientRow {
  uuid: string;
  patientName: string;
  unReadSmsCount: number;
  lastSms: string | null;
  lastSmsTime: string | null;
}

interface UsePatientsListProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey?: string;
  enabled?: boolean;
  unreadOnly?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export function useChatPatientsList({
  gridSorting,
  pagination,
  searchKey,
  enabled = true,
  unreadOnly = false,
}: UsePatientsListProps): useBaseContent<ChatPatientRow> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "chat-patients-list",
      pageSize,
      pageIndex,
      searchKey,
      unreadOnly,
    ],
    enabled: !!enabled,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new PatientControllerApi(getConfigObject())
        .getAllPatientForSmsRecord(
          // searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig
          pageIndex, //page
          pageSize, //size
          sortData?.field ?? undefined, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          searchKey,
          unreadOnly,
          getXtenantId()
        )
        .then((it) => asPaginatedContent<ChatPatientRow>(it?.data)),
  });
}
